<template>
    <nav class="header-navbar navbar-expand-lg navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center" data-nav="brand-center">
        <div class="navbar-container d-flex content">
            <div class="bookmark-wrapper d-flex align-items-center">
                <ul class="nav navbar-nav d-xl-none">
                    <li class="nav-item"><a class="nav-link menu-toggle" href="javascript:void(0);" @click="openMenu"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu ficon"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></a></li>
                </ul>
                <ul class="nav navbar-nav bookmark-icons">
                    <li class="nav-item d-none d-lg-block">
                        <a class="nav-link d-flex align-items-center" href="/">
                            <vue-feather type="home" class="ml-75 mr-75 icon" />
                            <span>Home</span>
                        </a>
                    </li>
                    <li class="nav-item d-none d-lg-block">
                        <a class="nav-link d-flex align-items-center" href="https://www.identityiq.com/sc-securepreferred.aspx?offercode=4312708Z">
                            <vue-feather type="book" class="ml-75 mr-75 icon" />
                            1 Dollar Credit Report
                        </a>
                    </li>
                    <li class="nav-item d-none d-lg-block">
                        <a class="nav-link d-flex align-items-center" href="https://affiliates.creditfixrr.com/signup">
                            <vue-feather type="dollar-sign" class="ml-75 mr-75 icon" />
                            Affiliate Program
                        </a>
                    </li>
                    <li class="nav-item d-none d-lg-block">
                        <router-link
                            :to="{ name: 'blogs' }"
                            class="nav-link d-flex align-items-center"
                            :class="urlChecker"
                        >
                            <vue-feather type="circle" class="ml-75 mr-75 icon" :class="urlChecker" />
                            Blogs
                        </router-link>
                    </li>
                    <li class="nav-item d-none d-lg-block">
                        <a class="nav-link d-flex align-items-center" :class="urlChecker" :href="$router.resolve({name: 'courses-guest'}).href" data-toggle="tooltip" data-placement="top" title="" data-original-title="Todo">
                            <vue-feather type="monitor" class="ml-75 mr-75 icon" :class="urlChecker"></vue-feather>
                            Courses
                        </a>
                    </li>
                </ul>
            </div>
            <ul class="nav navbar-nav align-items-center ml-auto">
                <li class="nav-item d-none d-lg-block">
                    <a class="nav-link d-flex align-items-center" :href="$router.resolve({ name: 'register' }).href">
                        <vue-feather type="user-check" class="ml-75 mr-75 icon" />
                        Create Account
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block">
                    <a class="nav-link d-flex align-items-center" :href="$router.resolve({ name: 'login' }).href">
                        <vue-feather type="log-in" class="ml-75 mr-75 icon" />
                        login
                    </a>
                </li>
            </ul>
        </div>
    </nav>
    <div id="collapse" class="main-menu menu-light menu-fixed menu-shadow d-lg-none" :class="openSideNav" role="navigation" data-menu="menu-wrapper" data-menu-type="floating-nav">
            <div class="navbar-header">
                <ul class="nav navbar-nav flex-row">
                    <li class="nav-item mr-auto"><a class="navbar-brand" href="#"><span class="">
                        <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-best-credit-repair-software-logo.png" alt="creditfixrr logo" width="150">
                    </span></a></li>
                    <li class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="#collapse" @click="closeMenu"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x d-block d-xl-none text-primary toggle-icon font-medium-4"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a></li>
                </ul>
            </div>
            <div class="shadow-bottom"></div>
            <!-- Horizontal menu content-->
            <div class="navbar-container main-menu-content ps ps--active-y" data-menu="menu-container">
                <!-- include ../../../includes/mixins-->
                <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="/" ><vue-feather type="home" class="ml-75 mr-75 icon"></vue-feather><span>Home</span></a></li>
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="https://www.identityiq.com/sc-securepreferred.aspx?offercode=4312708Z" ><vue-feather type="book" class="ml-75 mr-75 icon"></vue-feather><span>1 Dollar Credit Report</span></a></li>
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="https://affiliates.creditfixrr.com/signup"><vue-feather type="dollar-sign" class="ml-75 mr-75 icon"></vue-feather><span>Affiliate Program</span></a></li>
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="/blog" ><vue-feather type="circle" class="ml-75 mr-75 icon" :class="urlChecker"></vue-feather><span> Blog</span></a></li>
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="/register" ><vue-feather type="user-check" class="ml-75 mr-75"></vue-feather><span> Create Account</span></a></li>
                    <li class="nav-item has-sub"><a class="d-flex align-items-center" href="/login" ><vue-feather type="log-in" class="ml-75 mr-75"></vue-feather><span>login</span></a></li>
                </ul>
            <div class="ps__rail-x" style="left: 0px; bottom: 0px;"><div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div></div><div class="ps__rail-y" style="top: 0px; height: 413px; right: 0px;"><div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 276px;"></div></div></div>
        </div>
</template>
<script>
export default {
    name:'NavComponent',
    component:{

    },
    data() {
        return {
            open:false
        }
    },
    computed:{
        urlChecker(){
            let url = window.location.href;
            if(url.indexOf('/blog')){
                return 'primary'
            }else{
                return 'not-active'
            }
        },
        openSideNav(){
            if(this.open == true){
                return 'open-menu';
            }else{
                return '';
            }
        }
    },
    methods: {
        openMenu(){
            this.open =true;
        },
        closeMenu(){
            this.open=false;
        }
    },
}
</script>
<style scoped>
    .icon{
        width:18px;
        height:18px;
    }
    .header-navbar{
        position: fixed;
        width: 100%;
        background: white;
    }
    .main-menu{
        left: -264px;
        transition: left 1s;
    }
    .open-menu{
        left:0px !important;
        transition: left 1s;
    }
    @media (max-width: 767.98px){
        .main-menu {
            transform: translate3d(0, 0, 0);
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            perspective: 1000;
            left: -264px;
            transition: left 1s;
        }
    }
</style>